import { SelectedIndicator, useCompare } from '@iheartjane/menu';

interface CompareDotProps {
  focusCardMenu: () => void;
  onToggle: () => void;
  productId: number;
  productName: string;
}

export const CompareDot = ({
  focusCardMenu,
  onToggle,
  productId,
  productName,
}: CompareDotProps) => {
  const { isActive, isAtMax, isSelected, productCount } = useCompare();
  const selected = isSelected(productId);

  if (!isActive && !selected) return null;

  const exitsCompareMode = selected && productCount === 1;

  return (
    <SelectedIndicator
      disabled={isAtMax}
      isSelected={selected}
      onToggle={() => {
        onToggle();
        if (exitsCompareMode) focusCardMenu();
      }}
      productName={productName}
    />
  );
};
